/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 필터 버튼을 모아놓은 필터 바
 * 버전 : 1.0
 * 파일명 : FilterBar.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-16
 * ================================================================ 

 *=================================================================
 */

import styled from 'styled-components'
import { Icon_ArrowDown } from '../common/CommonIcons'
import { useDialogStore } from 'src/stores/DialogStore'
import DialogLocation from './DialogLocation'
import DialogUnvisited from './DialogUnvisited'
import DialogEdu_Level from './DialogEdu_Level'
import DialogNote_Level from './DialogNote_Level'

const PageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;

  height: 33px;
  font-size: 14px;
  font-weight: 400;
`

const ElementWrapper = styled.div<{ $choice: boolean, $changed:boolean }>`
  display: flex;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border-radius: 100px;
  border: 1px solid   ${({ $choice, $changed }) => $choice || $changed ? '#229596' :'#ddd'};
  color: ${({ $choice, $changed }) => $choice || $changed ? '#229596':'#000014'};
  background-color: ${({ $choice }) => $choice ? '#E5F4F8':'#fff'};
  font-weight: ${({ $choice, $changed }) => $choice ? '600': $changed ? '500':'400'};
  white-space: nowrap;
`

const FilterBar = () => {
  const setOpen = useDialogStore((state) => state.setOpen);
  const setField = useDialogStore((state) => state.setField);
  const elementValue = useDialogStore((state) => state.elementValue);
  const edu_level = useDialogStore((state) => state.edu_level);
  const highschool_type = useDialogStore((state) => state.highschool_type);
  const special_note = useDialogStore((state) => state.special_note);
  const start_date = useDialogStore((state) => state.start_date);
  const end_date = useDialogStore((state) => state.end_date);
  const onClickLocation = ()=>{
    setField('element',<DialogLocation/>)
    setField('elementValue','Location')
    setOpen(true)
  }

  const onClickUnvisited = ()=>{
    setField('element',<DialogUnvisited/>)
    setField('elementValue','Unvisit')
    setOpen(true)
  }

  const onClickEdu_Level = ()=>{
    setField('element',<DialogEdu_Level/>)
    setField('elementValue','Edu')
    setOpen(true)
  }

  const onClickNote_Level = ()=>{
    setField('element',<DialogNote_Level/>)
    setField('elementValue','Note')
    setOpen(true)
  }
  const isEduLevelDefault = Array.isArray(edu_level) && edu_level.length === 1 && edu_level[0] === 0;
  const isHighLevelDefault = Array.isArray(highschool_type) && highschool_type.length === 1 && highschool_type[0] === 0;
  const isSpecialNoteDefault = Array.isArray(special_note) && special_note.length === 1 && special_note[0] === 0;
  const isChanged = !(isEduLevelDefault && isHighLevelDefault);

  const isstartDateDefault = start_date !== '' && start_date !== null;
  const isendDateDefault = end_date !== '' && end_date !== null;

  const hasValidDateRange = isstartDateDefault || isendDateDefault;

  return (
    <PageWrapper>
      <ElementWrapper onClick={onClickLocation} $choice={elementValue === 'Location'} $changed={true}>
        지역
        <Icon_ArrowDown style={{color: '#229596', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickUnvisited} $choice={elementValue === 'Unvisit'} $changed={hasValidDateRange}>
        방문 기간
        <Icon_ArrowDown style={{color: elementValue === 'Unvisit' || hasValidDateRange ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickEdu_Level} $choice={elementValue === 'Edu'} $changed={isChanged}>
        학교 유형
        <Icon_ArrowDown style={{color: elementValue === 'Edu' || isChanged ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickNote_Level} $choice={elementValue === 'Note'} $changed={!isSpecialNoteDefault}>
        특이사항
        <Icon_ArrowDown style={{color: elementValue === 'Note' || !isSpecialNoteDefault ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
    </PageWrapper>
  )
}

export default FilterBar